let localDomain = localStorage.domain
let domain = !window.location.host.includes("localhost") ? window.location.host : localDomain ? localDomain : "engine.internetstrategylabs.com"
let origin = !window.location.host.includes("localhost") ? window.location.origin : localDomain ? `https://${localDomain}` : "https://engine.internetstrategylabs.com"

let setting = {
    layout: {
        pageSidebarMinified: false,
        pageFixedFooter: false,
        pageRightSidebar: false,
        pageTwoSidebar: false,
        pageTopMenu: false,
        pageBoxedLayout: false,
        pageWithoutSidebar: false,
        pageContentFullHeight: false,
        pageContentFullWidth: false,
        pageContentInverseMode: false,
        pageSidebarTransparent: false,
        pageWithFooter: false,
        pageLightSidebar: false,
        pageMegaMenu: false,
        pageBgWhite: false,
        pageWithoutHeader: false,
        paceTop: false,
        loginScreen: false,
        pageNoScroll: false
    },
    domain,
    oldOrigin: "https://app.theinsightsengine.io",
    origin,
    useAltStyle: true,
    assetThemePath: "assets/css/apple",
    topLevelName: domain === "app.franstats.com" ? 'Brand' : 'Company',
    topLevelNamePlural: domain === "app.franstats.com" ? 'Brands' : 'Companies',
    set: function(topKey, innerKey, value){

        if(topKey){
            setting[topKey][innerKey] = value
        } else {
            setting[innerKey] = value
    
        }
    }
}

export default setting